export enum DICTIONARY_CHANNEL_ENUM{
  /* 后台 */
  BACKGROUND = '1',
  /* 接口 */
  INTERFACE = '2',
}

// 字典启用禁用
export enum DICTIONARY_STATUS_ENUM{
  /* 启用 */
  ENABLE = '1',
  /* 禁用 */
  DISENABLE = '0',
}

export const DICTIONARY_STATUS_LIST = [
  {
    label: '启用',
    value: DICTIONARY_STATUS_ENUM.ENABLE,
  },
  {
    label: '禁用',
    value: DICTIONARY_STATUS_ENUM.DISENABLE,
  },
];

export enum ENABLED_ENUM{
  /* 启用 */
  ENABLED = 'YES',
  /* 停用 */
  DISABLED = 'NO',
}

export const ENABLED_LIST = [
  { value: ENABLED_ENUM.ENABLED, label: '启用' },
  { value: ENABLED_ENUM.DISABLED, label: '禁用' },
];
